import React from 'react';
import ChatBox from './react-chat/Chatbox'
import './index.css'


export default () => {
  return <ChatBox />;
};

